export default __webpack_public_path__ + "static/media/buildings-2.1f3b3e60.glb";